import * as React from 'react'
import './index.scss'
import { getTextByKey } from '@feedback/utils/util'

/**
 * 「不满意反馈」总开关：后端暂未支持 reason 落库，先隐藏弹层，
 * 两处 No 按钮走原先逻辑。后端就绪后翻 true 即恢复。
 * 显式标 boolean，避免 false 字面量把消费方另一分支判成 unreachable。
 */
export const DISSATISFACTION_ENABLED: boolean = false

/**
 * 马甲站「不满意反馈」底部弹层（对齐原型 dissatisfaction-sheet）。
 * FAQ 文章无用投票、工单对话 No 投票共用同一交互：
 * 标题 + 关闭 X + 反馈输入框 + 通栏品牌色 Submit，从底部滑出。
 *
 * reason 由父级决定去向（提交后端 / 前端收集）；本组件只管收集与回调。
 */
export interface VestDissatisfactionSheetProps {
  open: boolean
  /** 提交中禁用 Submit，避免重复提交 */
  submitting?: boolean
  onClose: () => void
  onSubmit: (reason: string) => void
}

const VestDissatisfactionSheet: React.FC<VestDissatisfactionSheetProps> = ({
  open,
  submitting,
  onClose,
  onSubmit
}) => {
  const [reason, setReason] = React.useState('')

  // 每次打开清空上一次的输入，避免残留
  React.useEffect(() => {
    if (open) setReason('')
  }, [open])

  if (!open) return null

  return (
    <div className='vest-dissatisfaction-layer'>
      <button
        type='button'
        className='vest-dissatisfaction-layer__mask'
        aria-label='Close dissatisfaction feedback'
        onClick={onClose}
      />
      <section className='vest-dissatisfaction-layer__sheet'>
        <header className='vest-dissatisfaction-layer__header'>
          <h2>{getTextByKey('Reasons for dissatisfaction')}</h2>
          <button
            type='button'
            className='vest-dissatisfaction-layer__close'
            aria-label='Close'
            onClick={onClose}
          />
        </header>
        <textarea
          className='vest-dissatisfaction-layer__input'
          placeholder={getTextByKey('Please input your feedback')}
          value={reason}
          onChange={(event) => setReason(event.target.value)}
        />
        <button
          type='button'
          className='vest-dissatisfaction-layer__submit'
          disabled={submitting}
          onClick={() => onSubmit(reason.trim())}
        >
          {getTextByKey('submit')}
        </button>
      </section>
    </div>
  )
}

export default VestDissatisfactionSheet
